import { Component, Input } from '@angular/core';

import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-processing',
  standalone: true,
  imports: [DialogModule, ProgressSpinnerModule],

  template: `<p-dialog
    [(visible)]="visible"
    [modal]="true"
    [showHeader]="true"
    [position]="'center'"
    [closeOnEscape]="false"
    [closable]="false"
    appendTo="body"
    styleClass="processing-dialog">
    <div class="grid">
      <div class="col-8 justify-content-start align-items-center mt-1">Processing Request...</div>
      <div class="col-4 justify-content-center align-items-center" style="padding-top:1rem;">
        <p-progressSpinner [style]="{ width: '35px', height: '35px' }" strokeWidth="5"></p-progressSpinner>
      </div>
    </div>
  </p-dialog>`,
  styles: []
})
export class ProcessingComponent {
  @Input() visible: boolean = false;
}
